// extracted by mini-css-extract-plugin
export default {"zoomModal":"X2-z"};